<div [ngClass]="{'iris-text-input-animation-container': !isReadonly}">
  <input 
    class="iris-text-input"
    [type]="type"
    [attr.aria-describedby]="formControlName
      && (control.touched | isControlInvalidAndTouched:control.invalid)
        ? formControlName + '-error-messages' : null"
    [attr.aria-invalid]="control.touched | isControlInvalidAndTouched:control.invalid"
    [attr.autocomplete]="autocomplete"
    [attr.required]="(control | isControlRequired) || null"
    [formControl]="control"
    [id]="formControlName"
    [textMask]="mask ? mask : {mask: false}"
    [name]="formControlName"
    [ngClass]="{'invalid': control.touched | isControlInvalidAndTouched:control.invalid}"
    [placeholder]="placeholder"
    [readonly]="isReadonly"
    [maxlength]="maxLength"
  />
</div>
